// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { IFileModel } from '../interfaces/file-model.interface';

/**
 * Sanitize HTML
 */
@Pipe({
  name: 'blobUrlToList',
})
export class BlobUrlToListPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param value: string
   */
  transform(value: string): IFileModel[] {
    try {
      if (value) return JSON.parse(value);
    } catch (error) {
      console.error('error while parsing image blog url', error);
    }

    return [];
  }
}
